import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStatCard = ({ title, value, icon, color, value1, label1, value2, label2 }) => {
    return (
        <div className={`bg-card rounded-lg border border-border p-6 shadow-soft hover:shadow-floating transition-smooth`}>
            <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center bg-${color}-100`}>
                    <div className={`text-${color}-500`}>
                        {icon}
                    </div>
                </div>
            </div>
            <div className="space-y-1">
                {value1 !== undefined && value2 !== undefined ? (
                    <>
                        <h3 className="text-2xl font-bold text-foreground">{value1}</h3>
                        <p className="text-sm font-medium text-muted-foreground">{label1}</p>
                        <h3 className="text-2xl font-bold text-foreground">{value2}</h3>
                        <p className="text-sm font-medium text-muted-foreground">{label2}</p>
                    </>
                ) : (
                    <h3 className="text-2xl font-bold text-foreground">{value}</h3>
                )}
                <p className="text-sm font-medium text-foreground">{title}</p>
            </div>
        </div>
    );
};

export default DashboardStatCard;